import * as React from "react";
import { useState } from "react";
import { Redirect } from "react-router-dom";
import logo from "modules/development/assets/images/rubk-logo.svg";
import {
  Grid,
  CssBaseline,
  Button,
  withStyles,
  Typography,
  Snackbar,
} from "@material-ui/core";
import { ProfileService } from "modules/profile/ProfileService";
import { LoginStore } from "modules/login/LoginStore";
import i18n from "i18n";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#000000,5%",
  },
  header: {
    backgroundColor: "#333",
    width: "100%",
    height: 64,
    padding: "20px 24px",
  },
  alingButtons: {
    backgroundColor: "#333",
    width: "100%",
    height: 64,
    padding: "20px 24px",
    alignItems: "center",
    justifyContent: "flex-end",
    display: "flex",
  },
  topBtn: {
    color: "#9AAF00",
    marginLeft: "15px",
    marginRight: "15px",
    border: "solid 1px #fafafa",
    "&:hover": {
      backgroundColor: "#fafafa",
    },
  },
  textTrial: {
    color: "#757575",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "23px",
  },
  titleForm: {
    color: "#9AAF00",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "23px",
    textTransform: "uppercase" as any,
  },
  checked: {
    display: "flex",
    alignItems: "flex-start",
    "& > span:nth-child(1)": {
      padding: " 0 12px",
    },
  },
  checked2: {
    padding: "0",
    color: "#9AAF00!important",
  },
  btnTeste: {
    backgroundColor: "#9AAF00",
    color: "#FFFFFF",
  },
  CardContent: {
    padding: "40px 32px 32px 32px",
  },
  margin: {
    margin: "10px 0px 5px 0",
    "& span": {
      fontSize: "12px",
    },
  },
  textField: {
    margin: "5px 0px",
  },
  formControl: {
    width: "100%",
  },
  iFrame: {
    display: "flex",
    justifyContent: "center",
    marginTop: "25px",
    "& iframe": {
      border: "none",
    },
  },
  success: {
    "& > div": {
      backgroundColor: "#198754!important",
    },
  },
  error: {
    "& > div": {
      backgroundColor: "#dc3545!important",
    },
  },
  formLoading: {
    height: "100%",
    width: "100%",
    backgroundColor: "RGBA(255,255,255, .7)",
    top: "0px",
    left: "0px",
    position: "absolute" as any,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
});

const CheckEmail = (props) => {
  const { classes } = props;
  const currentUser = LoginStore.userAuth;
  const [showSnack, setShowSnack] = useState(false);
  const [message, setMessage] = useState("");

  const sendEmail = () => {
    const user = ProfileService.getAuthData();
    if (user)
      user
        .sendEmailVerification()
        .then(() => showMessage("E-mail de verificação reenviado!"))
        .catch((error) => {
          console.error(error);
          showMessage(
            "Envios bloqueados por muitas tentativas. Tente novamente mais tarde!"
          );
        });
  };

  const showMessage = (message: string) => {
    setMessage(message);
    setShowSnack(true);
  };

  if (LoginStore.trialUserIsVerified()) {
    return <Redirect from="/menu/development" to="/menu/development" />;
  }

  return (
    <div>
      <React.Fragment>
        <CssBaseline />
        <Grid container>
          <Grid container>
            <Grid item xs={12}>
              <div className={classes.header}>
                <img style={{ height: "21px" }} src={logo} />
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.root}>
              <Grid container justify="center">
                <Grid item xs={6} style={{ padding: "30px 0px" }}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    align="center"
                    className={classes.titleForm}
                  >
                    {i18n.trialRegister.checkYourEmail}
                  </Typography>
                  <Typography
                    variant="body1"
                    gutterBottom
                    align="center"
                    className={classes.textTrial}
                    style={{ margin: "35px 0px" }}
                  >
                    {i18n.trialRegister.almostThere01} <br />
                    <br />
                    <b
                      style={{
                        margin: "-15px",
                      }}
                    >
                      {currentUser && currentUser.email}
                    </b>{" "}
                    <br />
                    <br />
                    {i18n.trialRegister.almostThere02}
                    <br />
                    {i18n.trialRegister.almostThere03}
                  </Typography>
                  <Typography
                    variant="body1"
                    gutterBottom
                    align="center"
                    className={classes.textTrial}
                    style={{ margin: "35px 0px 15px" }}
                  >
                    {i18n.trialRegister.almostThere04}
                  </Typography>
                  <Grid container direction="row" justify="center">
                    <Button
                      className={classes.btnTeste}
                      style={{ border: "none" }}
                      onClick={() => sendEmail()}
                    >
                      {i18n.trialRegister.resendEmail}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            open={showSnack}
            onClose={() => setShowSnack(false)}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={<span id="message-id">{message}</span>}
          />
        </Grid>
      </React.Fragment>
    </div>
  );
};

export default withStyles(styles)(CheckEmail);



// WEBPACK FOOTER //
// ./src/modules/login/components/pages/CheckEmail.tsx